// Import combineReducers from Redux
import { combineReducers } from 'redux';
import {
    fevicyrlContentReducer,
    workshopListReducer,
    workshopCmdiListReducer,
    paymentListReducer,
    workshopAmmdListReducer,
    paymentAmmdListReducer,
    myDatabaseReducer,
} from './utitlityReducer';

// Use Redux's combineReducers
export const rootReducer = combineReducers({
    fevicyrlContent: fevicyrlContentReducer,
    workshopList: workshopListReducer,
    workshopCmdiList: workshopCmdiListReducer,
    paymentList: paymentListReducer,
    workshopAmmdList: workshopAmmdListReducer,
    paymentAmmdList: paymentAmmdListReducer,
    myDatabaseList: myDatabaseReducer,
});
